export default class Workflow  {
    constructor(doctype) {
        this.doctype = doctype;
    }
    setup (doc) {
        const me = this;
        return frappe.call({
            method:'event_management.controllers.web_form.get_document_workflow_state',
            args: {
                doctype: me.doctype,
                doc: doc
            }}).then(r => {
                Object.assign(me, r.message);
            });
    }
    apply_workflow(doc, action) {
        return frappe.xcall('frappe.model.workflow.apply_workflow',
                        {doc: doc, action: action});
    }
}